  import { Fragment, useEffect, useState, useRef } from "react";
  import Footer from "../component/layout/footer";
  import Header from "../component/layout/header";
  import { Link, useParams } from "react-router-dom";
  import "./team-single.css";
  import Rating from "../component/sidebar/rating";
  import rimage from "../assets/images/art/profile_image.jpg"
  import { useNavigate } from "react-router-dom";
  import { jwtDecode } from "jwt-decode";
  import { createPortal } from "react-dom";
  import Swal from "sweetalert2";


  const formatLastLogin = (lastLogin) => {
      if (!lastLogin) return "Never logged in";
      
      try {
          const loginDate = new Date(lastLogin);
          const now = new Date();
          const diffMs = now - loginDate;
          const diffMins = Math.floor(diffMs / 60000);
          const diffHours = Math.floor(diffMs / 3600000);
          const diffDays = Math.floor(diffMs / 86400000);
          
          if (diffMins < 1) return "Just now";
          if (diffMins < 60) return `${diffMins} min${diffMins > 1 ? 's' : ''} ago`;
          if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
          if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
          
          // For older dates, show the actual date
          return loginDate.toLocaleDateString('en-US', { 
              year: 'numeric', 
              month: 'short', 
              day: 'numeric' 
          });
      } catch (err) {
          return "Date unavailable";
      }
  };

  const getGenderLabel = (gender) => {
    if (!gender) return "Not Specified";

    const value = gender.toString().trim().toLowerCase();

    if (value === "m" || value === "male") return "Male";
    if (value === "f" || value === "female") return "Female";
    if (value === "o" || value === "other") return "Other";

    // fallback for unexpected values
    return value.charAt(0).toUpperCase() + value.slice(1);
  };



  const getDayName = (dayId) => {
      const dayMap = {
          1: "Monday",
          2: "Tuesday",
          3: "Wednesday",
          4: "Thursday",
          5: "Friday",
          6: "Saturday",
          7: "Sunday",
      };

      return dayMap[Number(dayId)] || "Unknown";
  };


  const formatTime = (time) => {
      if (!time) return '';
      return time.substring(0, 5); // HH:mm format
  };

  // Age Group Display Component
  const AgeGroupDisplay = ({ agePreferences }) => {
      if (!agePreferences) return <span>Not specified</span>;

      const groups = [];
      if (agePreferences.under_10) groups.push('Under 10');
      if (agePreferences.age_10_to_15) groups.push('10-15 years');
      if (agePreferences.age_16_to_25) groups.push('16-25 years');
      if (agePreferences.above_25) groups.push('Above 25');

      return groups.length > 0 ? groups.join(', ') : 'Not specified';
  };

  // Availability Display Component
  const AvailabilityDisplay = ({ availability }) => {
      if (!availability || availability.length === 0) {
          return <span>No availability set</span>;
      }

      const activeSlots = availability.filter(slot => slot.is_active === 1);
      
      return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {activeSlots.length > 0 ? (
                  activeSlots.map((slot, idx) => (
                      <div key={idx} style={{ fontSize: '14px', display: 'flex', gap: '12px' }}>
                          <strong style={{ minWidth: '100px' }}>
                              {getDayName(slot.day_id)}:
                          </strong>
                          <span>
                              {formatTime(slot.start_time)} - {formatTime(slot.end_time)}
                          </span>
                      </div>
                  ))
              ) : (
                  <span>No active availability</span>
              )}
          </div>
      );
  };

  // Languages Display Component
  const LanguagesDisplay = ({ languages }) => {
      if (!languages || languages.length === 0) {
          return <span>Not specified</span>;
      }

      return (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {languages.map((lang) => (
                  <span
                      key={lang.id}
                      style={{
                          background: '#f0f0f0',
                          padding: '4px 12px',
                          borderRadius: '16px',
                          fontSize: '14px'
                      }}
                  >
                      {lang.language_name}
                  </span>
              ))}
          </div>
      );
  };




  // Class Modes Display Component
  const ClassModesDisplay = ({ classModes }) => {
      if (!classModes || classModes.length === 0) {
          return <span>Not specified</span>;
      }

      return (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {classModes.map((mode, idx) => (
                  <span
                      key={idx}
                      style={{
                          background: '#e8f4f8',
                          padding: '6px 12px',
                          borderRadius: '6px',
                          fontSize: '14px',
                          color: '#0066cc'
                      }}
                  >
                      {mode}
                  </span>
              ))}
          </div>
      );
  };

  const ProfileSkeleton = () => {
      return (
          // Add the wrapper div here
          <div className="skeleton-wrapper"> 
              <div className="container">
                  <div className="row">
                      {/* Left Side: Banners */}
                      <div className="col-lg-3">
                          <div className="skeleton-dark mb-3" style={{ width: '100%', height: '350px', borderRadius: '15px' }}></div>
                          <div className="skeleton-dark" style={{ width: '100%', height: '350px', borderRadius: '15px' }}></div>
                      </div>

                      {/* Right Side: Main Profile Card */}
                      <div className="col-lg-9">
                          <div className="p-5" style={{ background: '#111', borderRadius: '20px', border: '1px solid #333', height: '100%' }}>
                                <div className="d-flex align-items-center mb-5">
                              {/* Profile Image Circle */}
                              <div className="skeleton-dark" style={{ width: '120px', height: '120px', borderRadius: '50%' }}></div>
                              <div className="ms-4">
                                  {/* Name and Title */}
                                  <div className="skeleton-dark mb-2" style={{ width: '250px', height: '40px' }}></div>
                                  <div className="skeleton-dark" style={{ width: '150px', height: '20px' }}></div>
                              </div>
                          </div>

                          <div className="row">
                              <div className="col-md-7">
                                  {/* About Me & Experience */}
                                  <div className="skeleton-dark mb-3" style={{ width: '120px', height: '25px' }}></div>
                                  <div className="skeleton-dark mb-4" style={{ width: '100%', height: '60px' }}></div>
                                  
                                  <div className="skeleton-dark mb-3" style={{ width: '150px', height: '25px' }}></div>
                                  <div className="skeleton-dark" style={{ width: '80%', height: '20px' }}></div>
                              </div>

                              <div className="col-md-5">
                                  {/* Tutor Metrics Boxes */}
                                  <div className="skeleton-dark mb-3" style={{ width: '140px', height: '25px' }}></div>
                                  <div className="d-flex gap-2 mb-4">
                                      <div className="skeleton-dark" style={{ width: '60px', height: '60px', borderRadius: '8px' }}></div>
                                      <div className="skeleton-dark" style={{ width: '60px', height: '60px', borderRadius: '8px' }}></div>
                                      <div className="skeleton-dark" style={{ width: '60px', height: '60px', borderRadius: '8px' }}></div>
                                  </div>

                                  {/* Contact Info */}
                                  <div className="skeleton-dark mb-3" style={{ width: '140px', height: '25px' }}></div>
                                  <div className="skeleton-dark mb-2" style={{ width: '100%', height: '20px' }}></div>
                                  <div className="skeleton-dark mb-2" style={{ width: '90%', height: '20px' }}></div>
                                  <div className="skeleton-dark" style={{ width: '80%', height: '20px' }}></div>
                              </div>
                          </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      );
  };

  // --- TUTOR METRICS COMPONENT ---
  const TutorMetrics = ({ views, comments, likes }) => {
      const viewCount = parseInt(views) || 0;
      const commentCount = parseInt(comments) || 0;
      const likeCount = parseInt(likes) || 0;

      return (
          <div className="metrics-section-aurora">
              <h2 className="section-title-aurora">TUTOR METRICS</h2>
              <div className="metrics-grid">
                  <div className="metric-box">
                      <i className="fa-solid fa-eye"></i>
                      <p className="metric-value">{viewCount}</p>
                    
                  </div>
                  {/*<div className="metric-box">
                    <i className="fa-solid fa-comments"></i>
                      <p className="metric-value">{commentCount}</p>
                  
                  </div>*/}
                  <div className="metric-box">
                      <i className="fa-solid fa-heart"></i>
                      <p className="metric-value">{likeCount}</p>
                  
                  </div>
              </div>
          </div>
      );
  };


  const TutorStudentsDisplay = ({ tutorId, totalRequests, API_BASE }) => {
    
    return (
      <div className="requests-section-aurora">
        <h2 className="section-title-aurora">STUDENT REQUESTS</h2>
        <div className="requests-box">
          <div className="request-metric">
            <i className="fa-solid fa-users"></i>
            <div className="request-content">
              <p className="request-value">{totalRequests || 0}</p>
              <p className="request-label">Total Requests</p>
            </div>
          </div>
        </div>
      </div>
    );
  };


  // --- AURORA NIGHTINGALE PROFILE COMPONENT ---
  const AuroraNightingaleProfile = ({
    tutor,
     countries,
  getCurrencySymbol,
    awards,
    isLoggedIn,
    userRole,
    navigate,
    sendRequest,
    categories,
     request,  
    
  setrequest,
    filteredSkills,
      allSkills,
    setReqCategoryId,
    demoStatus, 
    setReqSkillId,
  reqDate,
    setReqDate,
    reqTime,
    setReqTime,
    reqRequirement,
    setReqRequirement,
    demoCategories,
    setDemoCategories,
    demoSkills,
    setDemoSkills,
    demoRequestId, 
    showPaymentPopup,          // 👈 ADD
    setShowPaymentPopup 
  }) => {
      






     

      const fullName = tutor?.tutor_type === "individual"
      ? tutor?.full_name || "General"
      : tutor?.full_name || "General";
      const title = tutor?.category || "Creative Professional";

      const profilePhotoUrl = tutor?.profile_photo 
          ? `https://kalakakshaaha.com/uploads/tutors/${tutor.profile_photo}` 
          : rimage;

      const firstName = fullName.split(" ")[0];
      const lastName = fullName.split(" ").slice(1).join(" ") || "";

  const [showImagePreview, setShowImagePreview] = useState(false);
const [previewImage, setPreviewImage] = useState("");
      const [cities, setCities] = useState([]);
      const [states, setStates] = useState([]);
    

  const [showCat, setShowCat] = useState(false);
  const [showSkill, setShowSkill] = useState(false);

        const address1 = tutor?.Address_line1 || tutor?.address_line1 || tutor?.address || "";
  const address2 = tutor?.Address_line2 || tutor?.address_line2 || "";
  const state = tutor?.state || "Not Specified";
  const city = tutor?.city || "Not Specified";
  const country = tutor?.country || "Not Specified";
  const [sessionCompleted, setSessionCompleted] = useState(1);
  const phone = tutor?.phone || "Not Specified";
  const email = tutor?.email || "Not Specified";
  const location = tutor?.location || "";
  const area = tutor?.area || "";
  const pincode = tutor?.pincode || "";
  const isPremiumTutor = Number(tutor?.is_premium) === 1;
  const canViewContact = isLoggedIn && isPremiumTutor;
  const [isPaid, setIsPaid] = useState(false);


const [expanded, setExpanded] = useState(false);

  const [showForm, setShowForm] = useState(false);

  // example role check (adjust based on your auth logic)

  const isStudent = userRole === "student";
  const [ratingValue, setRatingValue] = useState(0);
  const [ratingComment, setRatingComment] = useState("");
  const [submittingRating, setSubmittingRating] = useState(false);
  const [ratingError, setRatingError] = useState("");
  const token = localStorage.getItem("token");
  const decodedUser = token ? jwtDecode(token) : null;
  const studentId = decodedUser?.id || decodedUser?.user_id;// ✅ student user_id
  const [ratingSubmitted, setRatingSubmitted] = useState(false);
  const [branches, setBranches]=useState();



const handlePayment = async () => {
  const token = localStorage.getItem("token");
  const decoded = jwtDecode(token);

  const tutorId = tutor?.id || tutor?.tutor_id || tutor?.user_id;

  if (!tutorId) { alert("Tutor ID missing"); return; }
  if (!demoRequestId) { alert("Request not found"); return; }

  const key = `payment_done_${decoded.id}_${tutorId}_${demoRequestId}`;

  if (localStorage.getItem(key) === "true") {
    alert("You have already paid ✅");
    return;
  }

  try {
    // ✅ STEP 1: Create Razorpay order from backend
    const res = await fetch(
      "https://kalakakshaaha.com/kks/api/v1/demo-payment-initiate",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          tutor_id:   tutorId,
          student_id: studentId,
          request_id: demoRequestId,
          amount:     request?.price
        })
      }
    );

    const data = await res.json();

    if (!data.success) {
      alert("Payment initiation failed: " + (data.message || "Unknown error"));
      return;
    }

    // ✅ STEP 2: Open Razorpay popup
    if (!window.Razorpay) {
      Swal.fire("Error", "Razorpay failed to load. Please refresh.", "error");
      return;
    }

    const options = {
      key:       data.key,
      amount:    data.amount,
      currency:  "INR",
      name:      "Kala Kakshaaha",
      description: "Demo Session Payment",
      order_id:  data.order_id,

      handler: async function (response) {
        // ✅ STEP 3: Verify payment
        const verifyRes = await fetch(
          "https://kalakakshaaha.com/kks/api/v1/demo-payment-verify",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              order_id:   data.order_id,
              payment_id: response.razorpay_payment_id,
              signature:  response.razorpay_signature,
              request_id: demoRequestId
            })
          }
        );

        const verifyData = await verifyRes.json();

        if (verifyData.success) {
          localStorage.setItem(key, "true");
          setIsPaid(true);
          Swal.fire({
            icon: "success",
            title: "Payment Successful 🎉",
            text: "Your demo session is confirmed!",
          });
        } else {
          Swal.fire("Error", "Payment verification failed", "error");
        }
      },

      prefill: {
        name:  decoded?.name  || "",
        email: decoded?.email || "",
      },
      theme: { color: "#3399cc" }
    };

    const rzp = new window.Razorpay(options);
    rzp.open();

  } catch (err) {
    console.error("❌ Payment error:", err);
    alert("Server error");
  }
};




   
  const submitRating = async () => {
    if (!ratingValue || !ratingComment.trim()) {
      setRatingError("Rating and comment are required");
      return;
    }

    if (!studentId) {
      alert("Student ID missing. Please login again.");
      return;
    }

    const tutorId = tutor?.id || tutor?.user_id;
    if (!tutorId) {
      alert("Tutor ID missing");
      return;
    }

    try {
      setSubmittingRating(true);
      setRatingError("");

      const res = await fetch(
        "https://kalakakshaaha.com/kks/api/v1/tutors/comment", //  CORRECT API
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            tutor_id: tutorId,
            student_id: studentId, //  REQUIRED
            comment: ratingComment,
            rating: ratingValue,
            session_completed: sessionCompleted,    // ⭐ NEW
          }),
        }
      );

      const data = await res.json();

      if (!data.success) {
        throw new Error(data.message || "Failed to submit review");
      }

      // Reset

  setRatingSubmitted(true);

  const key = `rating_submitted_${studentId}_${tutor.id}`;
  localStorage.setItem(key, "true");


      setRatingValue(0);
      setRatingComment("");

      alert("Review submitted successfully!");

    } catch (err) {
      setRatingError(err.message);
    } finally {
      setSubmittingRating(false);
    }
  };





      const LastLoginSection = () => {
      const lastLogin = tutor?.last_login || null;
      const isOnline = lastLogin && (new Date() - new Date(lastLogin)) < 600000; // Online if logged in last 10 mins

      
      return (
          <div className="last-login-section-aurora">
              <div className="last-login-header">
              
                
              </div>
              <div className="last-login-content">
            
                      <i className="fa-solid fa-clock"></i>
                    Last active : {formatLastLogin(lastLogin)}
              
                  {/*lastLogin && (
                      <p className="last-login-full-date">
                          {new Date(lastLogin).toLocaleString()}
                      </p>
                  )*/}
              </div>
          </div>
      );
  };


  const tutorSkillIds = (tutor?.skills || "")
    .split(",")
    .map(id => Number(id))
    .filter(Boolean);

  const tutorSkills = tutorSkillIds
    .map(id => allSkills.find(skill => Number(skill.id) === id))
    .filter(Boolean);

  useEffect(() => {
    if (!tutor?.id || !studentId) return;

    const key = `rating_submitted_${studentId}_${tutor.id}`;
    setRatingSubmitted(localStorage.getItem(key) === "true");
  }, [tutor?.id, studentId]);

  useEffect(() => {
  console.log("BRANCHES DATA 👉", branches);
}, [branches]);
useEffect(() => {
  console.log("CITIES 👉", cities);
}, [cities]);


useEffect(() => {
  if (!studentId || !tutor?.id || !demoRequestId) return;

  const key = `payment_done_${studentId}_${tutor.id}_${demoRequestId}`;

  if (localStorage.getItem(key) === "true") {
    setIsPaid(true);
  }
}, [studentId, tutor?.id, demoRequestId]);

useEffect(() => {
  const tutorId = tutor?.id || tutor?.user_id || tutor?.tutor_id;

  if (!tutorId) return;

  fetch(`https://kalakakshaaha.com/kks/api/v1/tutor-branches/${tutorId}`)
    .then(res => res.json())
    .then(data => {
      

      if (data.success) {
        setBranches(data.data || []);
      }
    })
    .catch(err => console.error(err));
}, [tutor]);


useEffect(() => {
  fetch("https://kalakakshaaha.com/kks/api/v1/states")
    .then(res => res.json())
    .then(data => {
      if (data.success) setStates(data.states);
    });

  fetch("https://kalakakshaaha.com/kks/api/v1/cities")
    .then(res => res.json())
    .then(data => {
      if (data.success) setCities(data.cities);
    });
}, []);



  /*useEffect(() => {
      console.log("Social Media Data from Backend:", {
          instagram: tutor?.instagram,
          facebook: tutor?.facebook,
          youtube: tutor?.youtube
          website: tutor?.website
      });
  }, [tutor]);*/




      // This second log is redundant, removing it.
      // useEffect(() => {
    
      //     instagram: tutor?.instagram,
      //     facebook: tutor?.facebook,
      //     youtube: tutor?.youtube
      // });
      // }, [tutor]);

  // Helper to ensure links have protocol for safe navigation and rendering

  const hasActiveAvailability = (availability) => {
    if (!Array.isArray(availability)) return false;
    return availability.some(slot => slot.is_active === 1);
  };





  const hasAgePreferences = (agePreferences) => {
    if (!agePreferences) return false;
    return (
      agePreferences.under_10 ||
      agePreferences.age_10_to_15 ||
      agePreferences.age_16_to_25 ||
      agePreferences.above_25
    );
  };
  const toggleDemoCategory = (catId) => {
    setDemoCategories(prev => {
      let updated;
      if (prev.includes(catId)) {
        updated = prev.filter(id => id !== catId);
      } else {
        updated = [...prev, catId];
      }

      // Remove skills of unselected categories
      const allowedSkillIds = allSkills
        .filter(s => updated.includes(Number(s.category_id)))
        .map(s => s.id);

      setDemoSkills(prevSkills =>
        prevSkills.filter(id => allowedSkillIds.includes(id))
      );

      return updated;
    });
  };
    const demoFilteredSkills = allSkills.filter(skill =>
    demoCategories.includes(Number(skill.category_id))
  );
  const toggleDemoSkill = (skillId) => {
    setDemoSkills(prev =>
      prev.includes(skillId)
        ? prev.filter(id => id !== skillId)
        : [...prev, skillId]
    );
  };

  const ensureLinkProtocol = (link, platform) => {
      if (!link) return null;
      
      const normalizedLink = String(link).trim();
      
      // If it already has a protocol, return as-is
      if (normalizedLink.startsWith('http://') || normalizedLink.startsWith('https://')) {
          return normalizedLink;
      }
      
      // Platform-specific URL construction
      switch(platform) {
          case 'instagram':
              // Remove @ if present, then construct Instagram URL
              const instaHandle = normalizedLink.startsWith('@') ? normalizedLink.substring(1) : normalizedLink;
              return `https://www.instagram.com/${instaHandle}/`;
              
          case 'facebook':
              // Handle Facebook profile/page
              const fbHandle = normalizedLink.startsWith('@') ? normalizedLink.substring(1) : normalizedLink;
              return `https://www.facebook.com/${fbHandle}`;
              
          case 'youtube':
              // Handle YouTube channel
              const ytHandle = normalizedLink.startsWith('@') ? normalizedLink.substring(1) : normalizedLink;
              // Check if it's a channel ID (starts with UC) or username
              if (ytHandle.startsWith('UC')) {
                  return `https://www.youtube.com/channel/${ytHandle}`;
              } else {
                  return `https://www.youtube.com/@${ytHandle}`;
              }
              
          case 'website':
          default:
              // Generic website - just add https
              return `https://${normalizedLink}`;
      }
  };

  // --- SOCIAL MEDIA LINKS (Updated) ---
  const websiteUrl = ensureLinkProtocol(tutor?.website, 'website');
  const instagramUrl = ensureLinkProtocol(tutor?.instagram, 'instagram');
  const facebookUrl = ensureLinkProtocol(tutor?.facebook, 'facebook');
  const youtubeUrl = ensureLinkProtocol(tutor?.youtube, 'youtube');
const getCityName = (id) => {
  if (!id) return "";
  const city = cities.find(c => Number(c.id) === Number(id));
  return city ? (city.city_name || city.name || "") : "";
};

  const getStateName = (id) => {
  const state = states.find(s => s.id === Number(id));
  return state ? (state.state_name || state.name) : "";
};

const getCountryName = (id) => {
  const country = countries.find(c => c.id === Number(id));
  return country ? (country.country_name || country.name) : "";
};

  const hasAnySocialLink =
    !!websiteUrl || !!instagramUrl || !!facebookUrl || !!youtubeUrl;


      const totalViews = parseInt(tutor?.total_views) || 0;
      const totalComments = parseInt(tutor?.total_comments) || 0;
      const totalLikes = parseInt(tutor?.total_likes) || 0;

      return (
          <div className="aurora-profile-card">
              <div className="card-content-wrapper">
                  
  <div className="header-section-aurora">
    <div className="image-box">
    <img
  src={profilePhotoUrl}
  alt="Profile"
  className="profile-img-aurora clickable-avatar"
  onClick={() => {
    setPreviewImage(profilePhotoUrl);
    setShowImagePreview(true);
  }}
/>

    </div>

    <div className="name-box">

      {/* NAME */}
      <h1 className="role-title">
        {firstName} {lastName}
      </h1>

      {/* META INFO */}
      <div className="header-meta-line">
        <span>{title}</span>
        <span className="dot">•</span>
        <span>{getGenderLabel(tutor.gender)}</span>
        <span className="dot">•</span>
        <span>{tutor?.experience || "0"} yrs exp</span>
        <span className="dot">•</span>
        <LastLoginSection />
      </div>

    </div>
  </div>





                  {/* MAIN GRID */}
                  <div className="body-grid-aurora">
                      
                      {/* LEFT COLUMN */}
                      <div className="left-column-aurora">
                          
{/* ABOUT ME */}
<div className="about-me-section">
  <h2 className="section-title-aurora">Overview</h2>

  <div className="bio-wrapper">
    {(() => {
      const bioText = (
        tutor?.bio ||
        "Hello! I am a passionate educator dedicated to sharing my knowledge and helping students reach their full potential. With a learner-centric approach, I focus on building strong fundamentals, boosting confidence, and making each session engaging and effective. I adapt my teaching style to suit individual learning needs and goals."
      ).replace(/<\/?(p|br)\s*\/?>/g, "");

      const showToggle = bioText.length > 180; // adjust length if needed

      return (
        <>
          <div className={`bio-text ${expanded ? "expanded" : "collapsed"}`}>
            <p style={{ color: "white", margin: 0 }}>{bioText}</p>
          </div>

          {showToggle && (
            <span
              className="read-more-btn"
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? "Read Less" : "Read More"}
            </span>
          )}
        </>
      );
    })()}
  </div>
</div>

                           

                           


                          {/* GENDER 
                      <section style={{ marginBottom: '30px' }}>
                          <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '12px' ,color: '#70b8ff'}}>
                              GENDER
                          </h3>
                          <p style={{ color: '#f7f5f5ff' }}>
                              {getGenderLabel(tutor.gender)}
                          </p>
                      </section>*/}

                      {/* TEACHING LANGUAGES */}
                      <section style={{ marginBottom: '30px' }}>
                          <h3 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '12px' , color: '#70b8ff'}}>
                              TEACHING LANGUAGES
                          </h3>

                          <div style={{ color: '#457c9cff' }}>
    <LanguagesDisplay languages={tutor.languages} />
  </div>

                      </section>

                      {/* AGE GROUP */}
                    {hasAgePreferences(tutor.age_preferences) && (
    <section style={{ marginBottom: '30px' }}>
      <h3
        style={{
          fontSize: '14px',
          fontWeight: 'bold',
          marginBottom: '12px',
          color: '#70b8ff',
        }}
      >
        AGE GROUPS TAUGHT
      </h3>
      <AgeGroupDisplay agePreferences={tutor.age_preferences} />
    </section>
  )}


                      {hasActiveAvailability(tutor.availability) && (
    <section style={{ marginBottom: '30px' }}>
      <h3
        style={{
          fontSize: '14px',
          fontWeight: 'bold',
          marginBottom: '12px',
          color: '#70b8ff',
        }}
      >
        TUTOR AVAILABILITY
      </h3>
      <AvailabilityDisplay availability={tutor.availability} />
    </section>
  )}

                          {/* SKILLS */}
                        {tutorSkills.length > 0 && (
    <div className="skills-section-aurora">
      <h2 className="section-title-aurora">SUB CATEGORY</h2>

      <div className="skills-grid-aurora">
        {tutorSkills.map(skill => (
          <div
            key={skill.id}
            className="skill-icon-aurora"
            title={skill.skill_title}
          >
            <p className="skill-name-label">
              {skill.skill_title}
            </p>
          </div>
        ))}
      </div>
    </div>
  )}



                          {/* EXPERIENCE & AWARDS */}
  {Array.isArray(awards) && awards.length > 0 && (
    <section className="experience-section">
      <div className="divider"></div>

      <div className="experience-grid">
        <h3
          style={{
            fontSize: "14px",
            fontWeight: "bold",
            marginBottom: "12px",
            color: "#70b8ff",
          }}
        >
          AWARDS
        </h3>

        <div className="awards-horizontal-scroll">
          {awards.map((award) => {
            const image = award.image_url || award.image;

            return (
              <div key={award.id} className="award-card-horizontal">
                {image && (
                  <img
                    src={`https://kalakakshaaha.com/uploads/awards/${image}`}
                    alt={award.title}
                    className="award-image-horizontal"
                    onError={(e) => (e.target.style.display = "none")}
                  />
                )}
                <p className="award-title-horizontal">
                  {award.title}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  )}


  {/* ⭐ RATE & REVIEW */}
  {isLoggedIn && userRole === "student" && (
    <section className="aurora-rating-section" >
      <h2 className="section-title-aurora" style={{ marginTop: "50px" }}>RATE & REVIEW</h2>

      {ratingSubmitted ? (
        <p className="text-success text-center mt-3">
          Rating submitted successfully
        </p>
      ) : (
        <div className="rating-box">
          <StarRatingInput
            value={ratingValue}
            onChange={setRatingValue}
          />
          <div className="mt-3">
    <label  color="white">
      Session Completed?
    </label>

    <div className="d-flex gap-3">
      <label className="d-flex align-items-center gap-1">
        <input
          type="radio"
          name="session"
          value="1"
          checked={sessionCompleted === 1}
          onChange={() => setSessionCompleted(1)}
        />
        Yes
      </label>

      <label className="d-flex align-items-center gap-1">
        <input
          type="radio"
          name="session"
          value="0"
          checked={sessionCompleted === 0}
          onChange={() => setSessionCompleted(0)}
        />
        No
      </label>
    </div>
  </div>

          <textarea
            className="form-control mt-3"
            placeholder="Write your feedback..."
            value={ratingComment}
            onChange={(e) => setRatingComment(e.target.value)}
          />

          {ratingError && (
            <p className="text-danger mt-2">{ratingError}</p>
          )}

          <button
            className="btn btn-success mt-3 w-100"
            disabled={submittingRating}
            onClick={submitRating}
          >
            {submittingRating ? "Submitting..." : "Submit Review"}
          </button>
        </div>
      )}
    </section>
  )}



              


  {Number(tutor?.total_requests) > 0 && (
      <TutorStudentsDisplay 
          tutorId={tutor?.id}
          totalRequests={tutor?.total_requests}
          API_BASE="https://kalakakshaaha.com/kks/api/v1"
      />
  )}


  
                      </div>

                      {/* RIGHT COLUMN */}
                      <div className="right-column-aurora">


                          
                          {/* METRICS */}
                          <TutorMetrics 
                              views={totalViews}
                              comments={totalComments}
                              likes={totalLikes}
                          />


  <section style={{ marginBottom: "30px", borderRadius: "8px" }}>
    <h3
      style={{
        fontSize: "14px",
        fontWeight: "bold",
        marginBottom: "12px",
        color: "#70b8ff",
      }}
    >
      FEE PER SESSION
    </h3>

  <p
    style={{
      fontSize: "24px",
      fontWeight: "bold",
      color: "#fcfdfeff",
    }}
  >
    {tutor.fee_min !== null && tutor.fee_max !== null
      ?`${getCurrencySymbol()} ${Math.trunc(tutor.fee_min)} – ${getCurrencySymbol()} ${Math.trunc(tutor.fee_max)}`

      : "Not set"}
  </p>


  </section>


                      {/* CLASS MODES */}
                      <section style={{ marginBottom: '30px' }}>
                          <h3 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '12px', color: '#70b8ff' }}>
                              MODE OF CLASS
                          </h3>
                          
                          <ClassModesDisplay classModes={tutor.class_modes} />
                          
                      </section>

  {/* DEMO AVAILABILITY */}
  {Number(tutor?.is_demo_available) === 1 && (
    <section style={{ marginBottom: '30px' }}>
      <h3
        style={{
          fontSize: '18px',
          fontWeight: 'bold',
          marginBottom: '12px',
          color: '#70b8ff',
        }}
      >
        DEMO CLASS 
      </h3>

      <img
        src="../assets/images/art/Demo.png"
        alt="Demo Available"
        style={{ width: '120px' }}
      />
      
    </section>
  )}

  {/* SEND REQUEST BUTTON */}
  {/* SEND REQUEST FORM */}

<section style={{ marginBottom: "30px" }}>

  {/* ================= PAY NOW ================= */}
{request && request.status === 1 && request.tutor_status === 1 && Number(request.price) > 0 && (
  <button
    className={`btn w-100 ${isPaid ? "btn-success" : "btn-primary"}`}
    disabled={isPaid}
    //onClick={!isPaid ? handlePayment : undefined}
  >
    {/*{isPaid ? "✔ Paid" : `Pay ₹${request.price}`}*/} Payment Pending
  </button>
)}

  {/* ================= WAITING FOR ADMIN ================= */}
  {request?.status === 0 && (
    <button disabled className="btn btn-warning w-100">
      ⏳ Waiting for Admin Approval
    </button>
  )}

  {/* ================= WAITING FOR TUTOR ================= */}
  {request?.status === 1 && request?.tutor_status === 0 && (
    <button disabled className="btn btn-warning w-100">
      ⏳ Waiting for Tutor Approval
    </button>
  )}

  {/* ================= REJECTED ================= */}
  {request?.status === 2 && (
    <button disabled className="btn btn-danger w-100">
      ❌ Demo Request Rejected
    </button>
  )}

  {/* ================= REQUEST SENT (LOADING STATE) ================= */}
  {!request && tutor?.request_status === 0 && (
    <button disabled className="sent-btn w-100">
      <h3 style={{ color: "white" }}>Request Sent</h3>
    </button>
  )}

  {/* ================= NO REQUEST YET ================= */}
  {!request && !tutor?.request_status && (
    <>
      {!showForm && (
        <button
          className="btn btn-primary w-100"
          disabled={!isStudent}
          onClick={() => isStudent && setShowForm(true)}
        >
          <i className="fa-solid fa-circle-play me-2"></i>
          Send Demo Request
        </button>
      )}

      {!isStudent && (
        <small className="text-muted d-block mt-2 text-center">
          Only students can send demo requests
        </small>
      )}

      {showForm && isStudent && (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            sendRequest();
          }}
          className="mt-3"
        >

          <input
            type="date"
            required
            value={reqDate}
            onChange={(e) => setReqDate(e.target.value)}
            className="form-control mb-2"
          />

          <input
            type="time"
            required
            value={reqTime}
            onChange={(e) => setReqTime(e.target.value)}
            className="form-control mb-2"
          />

          {/* CATEGORY */}
          <div className="dropdown-field mb-3">
            <div className="dropdown-input" onClick={() => setShowCat(!showCat)}>
              {demoCategories.length > 0
                ? demoCategories
                    .map(id => categories.find(c => c.id === id)?.category_name)
                    .join(", ")
                : "Select Categories"}
              <span>▼</span>
            </div>

            {showCat && (
              <div className="dropdown-panel">
                {categories.map(cat => (
                  <label key={cat.id} className="dropdown-option">
                    <span className="option-text">{cat.category_name}</span>
                    <input
                      type="checkbox"
                      checked={demoCategories.includes(cat.id)}
                      onChange={() => toggleDemoCategory(cat.id)}
                    />
                  </label>
                ))}
              </div>
            )}
          </div>

          {/* SKILLS */}
          <div className="dropdown-field mb-3">
            <div
              className={`dropdown-input ${demoCategories.length === 0 ? "disabled" : ""}`}
              onClick={() => demoCategories.length && setShowSkill(!showSkill)}
            >
              {demoSkills.length > 0
                ? demoSkills
                    .map(id => allSkills.find(s => s.id === id)?.skill_title)
                    .join(", ")
                : "Select Sub Categories"}
              <span>▼</span>
            </div>

            {showSkill && (
              <div className="dropdown-panel">
                {demoFilteredSkills.map(skill => (
                  <label key={skill.id} className="dropdown-option">
                    <span className="option-text">{skill.skill_title}</span>
                    <input
                      type="checkbox"
                      checked={demoSkills.includes(skill.id)}
                      onChange={() => toggleDemoSkill(skill.id)}
                    />
                  </label>
                ))}
              </div>
            )}
          </div>

          <textarea
            required
            className="form-control mb-3"
            placeholder="Describe your requirement"
            value={reqRequirement}
            onChange={(e) => setReqRequirement(e.target.value)}
          />

          <button type="submit" className="btn btn-success w-100">
            <i className="fa-solid fa-paper-plane me-2"></i>
            Send Request
          </button>

        </form>
      )}
    </>
  )}

</section>





  {/* ================= CONTACT SECTION ================= */}
  {!isLoggedIn ? (
    /* ---------- NOT LOGGED IN ---------- */
    <div className="contact-section locked-contact">
    
      <div className="divider"></div>

  
      <button
        className="email-button-aurora"
        onClick={() => navigate("/login")}
      >
        <i className="fa-solid fa-lock"></i> Login
      </button>
    </div>

  ) : !isPremiumTutor ? (
    /* ---------- LOGGED IN BUT NOT PREMIUM ---------- */
    <div className="contact-section locked-contact">
    
      <div className="divider"></div>


      
    </div>

  ) : (
    /* ---------- PREMIUM (SHOW EVERYTHING) ---------- */
    <div className="contact-section">

      {/* CONNECT */}
      <div className="connect-section-aurora">
        <h2 className="section-title-aurora">CONNECT</h2>

        <div className="social-icons-grid">
                            {hasAnySocialLink && (
    <div className="connect-section-aurora">


      <div className="social-icons-grid">
        {websiteUrl && (
          <a
            href={websiteUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon-item"
          >
            <i className="fa-solid fa-globe"></i>
            <p>Website</p>
          </a>
        )}

        {instagramUrl && (
          <a
            href={instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon-item"
          >
            <i className="fa-brands fa-instagram"></i>
            <p>Instagram</p>
          </a>
        )}

        {facebookUrl && (
          <a
            href={facebookUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon-item"
          >
            <i className="fa-brands fa-facebook"></i>
            <p>Facebook</p>
          </a>
        )}

        {youtubeUrl && (
          <a
            href={youtubeUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon-item"
          >
            <i className="fa-brands fa-youtube"></i>
            <p>YouTube</p>
          </a>
        )}
      </div>
    </div>
  )}
        </div>
      </div>

      {/* CONTACT INFO */}
      <h2 className="highlight-title">Contact Info</h2>

      <div className="divider"></div>

      <ul className="contact-details-list">

        {address1 && address2 && location && area && (
          <li>
            <i className="fa-solid fa-location-dot"></i>
          {address1}, {address2} , {location} , {area}
          </li>
        )}
        
        
      
        {(city || state || country || pincode) && (
          <li>
            <i className="fa-solid fa-city"></i>
            {[city, state, country, pincode].filter(Boolean).join(", ")}
          </li>
        )}
        

        {phone && (
          <li>
            <i className="fa-solid fa-phone"></i>
            {phone}
          </li>
        )}

        {email && (
          <li>
            <i className="fa-solid fa-envelope"></i>
            {email}
          </li>
        )}

      </ul>

      {/* ================= BRANCHES ================= */}
      {branches && branches.length > 0 && (
  <section style={{ marginBottom: "30px" }}>
    <h3
      style={{
        fontSize: "14px",
        fontWeight: "bold",
        marginBottom: "12px",
        color: "#70b8ff",
      }}
    >
      BRANCHES / LOCATIONS
    </h3>

    {branches.map((branch) => (
      <div
        key={branch.id}
        style={{
          display: "flex",
          gap: "10px",
          marginBottom: "10px",
          color: "#fff",
        }}
      >
        <i className="fa-solid fa-location-dot"></i>
  <div  style={{color:"#E1D064"}}>
        <span>
          
          {[
            branch.address_line1,
            branch.address_line2,
            branch.area,
            branch.location,
           getCityName(branch.city),
getStateName(branch.state),
getCountryName(branch.country),
          ]
            .filter(Boolean)
            .join(", ")}

          {branch.pincode && ` - ${branch.pincode}`}
        </span>
        </div>
      </div>
    ))}
  </section>
)}
    </div>
  )}




{/* IMAGE PREVIEW MODAL */}
{showImagePreview &&
  createPortal(
    <div
      className="image-preview-overlay"
      onClick={() => setShowImagePreview(false)}
    >
      <div
        className="image-preview-container"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="image-preview-close"
          onClick={() => setShowImagePreview(false)}
        >
          ✕
        </button>

        <img src={previewImage} alt="Preview" />
      </div>
    </div>,
    document.body
  )}

                      </div>
                  </div>
              </div>
          </div>
      );
  };


  const StarRatingInput = ({ value, onChange }) => {
    return (
      <div style={{ display: "flex", gap: "8px" }}>
        {[1, 2, 3, 4, 5].map((star) => (
          <i
            key={star}
            className={`fa-star fa-solid ${
              star <= value ? "text-warning" : "text-muted"
            }`}
            style={{ cursor: "pointer", fontSize: "22px" }}
            onClick={() => onChange(star)}
          />
        ))}
      </div>
    );
  };

  // === MAIN TEAM SINGLE COMPONENT ===
  // === MAIN TEAM SINGLE COMPONENT ===
  const TeamSingle = () => {
      const { slug } = useParams();
      const navigate = useNavigate();
      const hasIncrementedView = useRef(false);


      const [categories, setCategories] = useState([]);
      const query = new URLSearchParams(window.location.search);
      const id = query.get("id");

      const [tutor, setTutor] = useState(null);
      const [awards, setAwards] = useState([]);
      const [adsList, setAdsList] = useState([]);
      const [isLoggedIn, setIsLoggedIn] = useState(false);
      const [loading, setLoading] = useState(true);
      const [error, setError] = useState(null);
      
          const [demoCategories, setDemoCategories] = useState([]);
      const [demoSkills, setDemoSkills] = useState([]);
      const [userRole, setUserRole] = useState(null);
  const [reqDate, setReqDate] = useState("");
  const [reqTime, setReqTime] = useState("");
  const [reqCategoryId, setReqCategoryId] = useState("");
  const [reqSkillId, setReqSkillId] = useState("");
  const [reqRequirement, setReqRequirement] = useState("");

  const [demoStatus, setDemoStatus] = useState(null); // 0 | 1 | 2
  const [showPaymentPopup, setShowPaymentPopup] = useState(false);

  const [demoStatusLoaded, setDemoStatusLoaded] = useState(false);
  const [countries, setCountries] = useState([]);
 const [request,setrequest]=useState(null);
const [demoRequestId,setdemoRequestId] = useState(null);



  const [allSkills, setAllSkills] = useState([]);

  const filteredSkills = allSkills.filter(
    (skill) => Number(skill.category_id) === Number(reqCategoryId)
  );



      const fallbackAds = [
          { imgUrl: "https://kalakakshaaha.com/kks/uploads/ads/sing1.png" },
          { imgUrl: "https://kalakakshaaha.com/kks/uploads/ads/sing2.png" },
          
      ];

      const API_BASE = "https://kalakakshaaha.com/kks/api/v1";

      // Map skills to categories based on skill IDs
      const skillToCategoryMap = {
          // Dance (1): skills 1-17
          '1': 1, '2': 1, '3': 1, '4': 1, '5': 1, '6': 1, '8': 1, '9': 1, '10': 1, '11': 1, '12': 1, '13': 1, '14': 1, '15': 1, '16': 1, '17': 1,
          // Music (2): skills 7, 18-30, 31, 87
          '7': 2, '18': 2, '19': 2, '20': 2, '21': 2, '22': 2, '23': 2, '24': 2, '25': 2, '26': 2, '27': 2, '28': 2, '29': 2, '30': 2, '31': 2, '87': 2,
          // Painting and Drawing (3): skills 32-35
          '32': 3, '33': 3, '34': 3, '35': 3,
          // Sculpture (4): skills 36, 56-62, 81, 84, 85
          '36': 4, '56': 4, '57': 4, '58': 4, '59': 4, '60': 4, '61': 4, '62': 4, '81': 4, '84': 4, '85': 4,
          // Theatre Arts (5): skills 37-47
          '37': 5, '38': 5, '39': 5, '40': 5, '41': 5, '42': 5, '43': 5, '44': 5, '45': 5, '46': 5, '47': 5,
          // Yoga (6): skill 49
          '49': 6,
          // Martial Arts (7): skills 51-54
          '51': 7, '52': 7, '53': 7, '54': 7,
          // Crafts (8): skills 55, 63-69
          '55': 8, '63': 8, '64': 8, '65': 8, '66': 8, '67': 8, '68': 8, '69': 8,
          // Beauty (9): skills 63-67
          '63': 9, '64': 9, '65': 9, '66': 9, '67': 9,
          // Foreign Languages (11): skills 74-78
          '74': 11, '75': 11, '76': 11, '77': 11, '78': 11,
          // AI and IT (12): skills 79-80
          '79': 12, '80': 12,
          // Physiotherapy (6 or custom): skill 50
          '50': 6,
          // Yoga (6): skill 49
          '48': 6,
          // Photography (3 or custom): skill 94
          '94': 3,
      };




  const sendRequest = async () => {
  if (!reqDate || !reqTime || demoCategories.length === 0 || demoSkills.length === 0 || !reqRequirement) {
    alert("All fields are mandatory");
    return;
  }


    // ✅ SAFE tutor id resolution
    const tutorId =
      tutor?.id ||
      tutor?.tutor_id ||
      tutor?.user_id;

    if (!tutorId) {
      alert("Tutor ID missing. Please reload the page.");
      return;
    }

  /* console.log("SENDING REQUEST:", {
      tutorId,
      reqDate,
      reqTime,
      reqCategoryId,
      reqSkillId,
      reqRequirement,
    });*/

    const token = localStorage.getItem("token");

    const res = await fetch(
      "https://kalakakshaaha.com/kks/api/v1/request/send",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          tutor_id: tutorId, // ✅ FIXED
          categories: demoCategories,   // [1,2,5]
          skills: demoSkills,   
          date: reqDate,
          time: reqTime,
          requirement: reqRequirement,
          
        }),
      }
    );

    const text = await res.text();

    try {
      const data = JSON.parse(text);

if (data.success) {
  setDemoStatus(0);
  // Refetch the actual request status from API
  const token = localStorage.getItem("token");
  const tutorId = tutor?.id || tutor?.tutor_id || tutor?.user_id;
  fetch(`${API_BASE}/request/status/${tutorId}`, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then(res => res.json())
    .then(data => {
      if (data.success && data.data) {
        setrequest({
          status: Number(data.data.status),
          tutor_status: Number(data.data.tutor_status),
          price: Number(data.data.price)
        });
      }
    });
} else {
        alert(data.message || "Request failed");
      }

    } catch (err) {
      console.error("❌ API returned non-JSON:", text);
      alert("Server error. Please try again later.");
    }
  };









      // Check login status
      useEffect(() => {
          const token = localStorage.getItem("token");
          if (token) {
              try {
                  const decoded = jwtDecode(token);
        setIsLoggedIn(true);
        setUserRole(decoded.role);
                  }
              catch (err) {
                  console.log("Invalid token");
              }
          }
      }, []);


      useEffect(() => {
    fetch("https://kalakakshaaha.com/kks/api/v1/countries")
      .then(res => res.json())
      .then(data => {
        if (data.success) setCountries(data.countries);
      });
  }, []);
  const getCurrencySymbol = () => {
    if (!tutor?.country_id || !countries.length) return "₹";

    const country = countries.find(
      c => String(c.id) === String(tutor.country_id)
    );

    return country?.currency_symbol || "₹";
  };


      // Fetch categories - FIRST PRIORITY
      useEffect(() => {
          const fetchCategories = async () => {
              try {
                
                  const res = await fetch(`${API_BASE}/categories`);
                  
                  
                  
                  const contentType = res.headers.get("content-type");
                

                  if (!contentType || !contentType.includes("application/json")) {
                      const text = await res.text();
                      //console.error("❌ Categories API did not return JSON:", text.substring(0, 200));
                      setCategories([]);
                      return;
                  }

                  const data = await res.json();
                
                  
                  if (data.success && data.categories && Array.isArray(data.categories)) {
                    
                      setCategories(data.categories);
                      data.categories.slice(0, 3).forEach(cat => {
                      
                      });
                  } else {
                    // console.warn("⚠ Unexpected categories structure:", data);
                      setCategories([]);
                  }
              } catch (err) {
                // console.error("❌ Categories fetch error:", err);
                  setCategories([]);
              }
          };
          
          fetchCategories();
      }, []);
      
  useEffect(() => {
    const token = localStorage.getItem("token");
    const tutorId = tutor?.id || tutor?.user_id || tutor?.tutor_id;

    if (!token) return ;
    if (!tutorId) return ;
    if (!userRole) return ;



    fetch(`${API_BASE}/request/status/${tutorId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => res.json())
      .then(data => {

      if (data.success && data.data) {

  setDemoStatus(Number(data.data.status));

  setdemoRequestId(data.data.request_id);   // ⭐ IMPORTANT
if (data.success && data.data) {

  setDemoStatus(Number(data.data.status));
  setdemoRequestId(data.data.request_id);

  setrequest({
    status: Number(data.data.status),
    tutor_status: Number(data.data.tutor_status),
    price: Number(data.data.price)
  });

} else {
  setrequest(null);
}                // ⭐ save price + token

} else {
          setDemoStatus(null);
        }
      })
      .catch(err => {
        console.error("❌ STATUS FETCH FAILED:", err);
        setDemoStatus(null);
      });
  }, [tutor, userRole]);






  useEffect(() => {
    fetch("https://kalakakshaaha.com/kks/api/v1/total-skills")
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setAllSkills(data.skills);
        }
      });
  }, []);



      useEffect(() => {
      hasIncrementedView.current = false;
  }, [id]);





      // Main data fetching - WAITS FOR CATEGORIES
      useEffect(() => {
          if (!id) {
              //console.error("❌ No tutor ID in URL");
              setError("No tutor ID provided");
              setLoading(false);
              return;
          }

          // Only proceed if categories are loaded
          if (categories.length === 0) {
          
              return;
          }



          

        

          const fetchData = async () => {
              try {
                  setLoading(true);
                  setError(null);

              const token = localStorage.getItem("token");

  const tutorRes = await fetch(`${API_BASE}/tutor/${id}`, {
    headers: token
      ? { Authorization: `Bearer ${token}` }
      : {}
  });

                  
              

                  const contentType = tutorRes.headers.get("content-type");
                  if (!contentType || !contentType.includes("application/json")) {
                      const errorText = await tutorRes.text();
                      //console.error("❌ Server did not return JSON. Received:", errorText.substring(0, 200));
                      throw new Error(`Server Error: Invalid response format (expected JSON, received HTML/Text). Check backend logs for ID ${id}.`);
                  }

                  const tutorData = await tutorRes.json();

                  //console.log("📊 FULL TUTOR API RESPONSE:", tutorData);
          //console.log("last_login value:", tutorData?.last_login || tutorData?.data?.last_login);

                  let tutorInfo = null;

                  // Robust logic to parse different potential API response structures
                  if (tutorData.success && tutorData.data) {
                      tutorInfo = tutorData.data;
                    
                  } else if (tutorData.success && tutorData.tutor) {
                      tutorInfo = tutorData.tutor;
                  
                  } else if (!Array.isArray(tutorData) && typeof tutorData === 'object' && tutorData.full_name) {
                      tutorInfo = tutorData;
                  
                  } else if (Array.isArray(tutorData) && tutorData.length > 0) {
                      tutorInfo = tutorData[0];
                    
                  }

                  if (!tutorInfo || !tutorInfo.full_name) {
                      //console.error("❌ Invalid tutor response:", tutorData);
                      throw new Error(`Tutor with ID ${id} not found or data missing.`);
                  }


                                if (!tutorInfo.last_login && tutorData.data && tutorData.data.last_login) {
              tutorInfo.last_login = tutorData.data.last_login;
          }

          //console.log("✅ Extracted last_login:", tutorInfo.last_login);
          //console.log("✅ Full tutorInfo object:", tutorInfo);


              


                

                  // Ensure metrics are numbers or 0
                  tutorInfo.total_views = parseInt(tutorInfo.total_views) || 0;
                  tutorInfo.total_comments = parseInt(tutorInfo.total_comments) || 0;
                  tutorInfo.total_likes = parseInt(tutorInfo.total_likes) || 0;

            
                  setTutor(tutorInfo); 
                    
                  
                  

                
          // --- 2. Fetch Ads (GLOBAL ONLY) ---
try {
  const adsRes = await fetch(`${API_BASE}/ads_api.php`);

  const contentType = adsRes.headers.get("content-type");
  if (!contentType || !contentType.includes("application/json")) {
    throw new Error("Ads API did not return JSON");
  }

  const adsData = await adsRes.json();

  if (adsData.success && Array.isArray(adsData.ads) && adsData.ads.length > 0) {
    setAdsList(adsData.ads);
  } else {
    setAdsList(fallbackAds);
  }
} catch (err) {
  setAdsList(fallbackAds);
}
                  

                  // --- 3. Fetch Awards ---
                  try {
                    
                      const awardsRes = await fetch(`${API_BASE}/awards_api.php?tutor_id=${id}`);
                      const contentType = awardsRes.headers.get("content-type");
                      if (!contentType || !contentType.includes("application/json")) {
                          throw new Error("Awards API did not return JSON");
                      }
                      const awardsData = await awardsRes.json();
                  
                      if (awardsData.success && awardsData.awards) {
                          setAwards(awardsData.awards);
                      } else if (Array.isArray(awardsData)) {
                          setAwards(awardsData);
                      } else {
                          setAwards([]);
                      }
                  } catch (err) {
                    
                      setAwards([]);
                  }

                  setLoading(false);
              } catch (err) {
                
                  setError(err.message); 
                  setLoading(false);
              }
          };

          fetchData();
      }, [id, categories]);

      if (loading) {
          return (
              <Fragment>
                  <Header />
                  <ProfileSkeleton />
              </Fragment>
          );
      }

      if (error) {
          return (
              <Fragment>
                  <Header />
                  <div className="container" style={{ marginTop: "100px", textAlign: "center" }}>
                      <div style={{ padding: "40px" }}>
                          <i className="fa-solid fa-exclamation-circle" style={{ fontSize: "48px", color: "#ff6b6b", marginBottom: "20px" }}></i>
                          <h3>Failed to Load Profile</h3>
                          <p><strong>Error:</strong> {error}</p>
                          <p style={{ fontSize: "14px", color: "#666", marginTop: "10px" }}>
                              Check browser console (F12) for more details
                          </p>
                          <button
                              onClick={() => window.location.reload()}
                              style={{
                                  padding: "10px 20px",
                                  background: "#667eea",
                                  color: "white",
                                  border: "none",
                                  borderRadius: "6px",
                                  cursor: "pointer",
                                  marginTop: "20px"
                              }}
                          >
                              <i className="fa-solid fa-rotate-right"></i> Retry
                          </button>
                      </div>
                  </div>
                  <Footer />
              </Fragment>
          );
      }

      
      if (!tutor) {
          return (
              <Fragment>
                  <Header />
                  <div className="container" style={{ marginTop: "100px", textAlign: "center", padding: "40px" }}>
                      <i className="fa-solid fa-user-slash" style={{ fontSize: "48px", color: "#999", marginBottom: "20px" }}></i>
                      <p style={{ fontSize: "18px" }}>Tutor not found</p>
                  </div>
                  <Footer />
              </Fragment>
          );
      }

      return (
          <Fragment>
              <Header />

              <section className="tutor-modern-wrapper aurora-background-scene">
                  <div className="container" style={{ marginTop: "100px" }}>
                      <div className="row align-items-stretch">
                          
                          {/* LEFT SIDE ADS */}
                         
  {showPaymentPopup && (
    <div className="payment-overlay">
      <div className="payment-modal">
        <h3 className="text-center mb-3">Complete Your Payment</h3>

        <div className="pay-box">
          <p><strong>Tutor:</strong> {tutor?.full_name}</p>
          <p><strong>Amount:</strong> ₹{request?.price || tutor?.hourly_fee || 500}</p>
        </div>

        <div className="fake-razorpay-box">
          <p className="rzp-title">Razorpay Secure</p>

          {/* <input className="form-control mb-2" placeholder="Card Number" />
          <input className="form-control mb-2" placeholder="MM / YY" />
          <input className="form-control mb-3" placeholder="CVV" /> */}

          <button
            className="btn btn-primary w-100"
            onClick={() => {
              alert("Payment Successful (UI only)");
              setShowPaymentPopup(false);
            }}
          >
            Payment Request
          </button>
        </div>

        <button
          className="close-btn"
          onClick={() => setShowPaymentPopup(false)}
        >
          ✕
        </button>
      </div>
    </div>
  )}

                          {/* RIGHT SIDE PROFILE */}
                          <div className="col-lg-9 col-md-8">
                            <AuroraNightingaleProfile
    tutor={tutor}
      countries={countries}  
    getCurrencySymbol={getCurrencySymbol}
      request={request}
  setrequest={setrequest}
  demoRequestId={demoRequestId}
    awards={awards}
    isLoggedIn={isLoggedIn}
    userRole={userRole}
    navigate={navigate}
    sendRequest={sendRequest}
    categories={categories}
    demoStatus={demoStatus}   
    filteredSkills={filteredSkills}
    setReqCategoryId={setReqCategoryId}
    setReqSkillId={setReqSkillId}
    reqDate={reqDate}
    allSkills={allSkills}
    setReqDate={setReqDate}
    reqTime={reqTime}
    setReqTime={setReqTime}
    reqRequirement={reqRequirement}
    setReqRequirement={setReqRequirement}
      demoCategories={demoCategories}
  setDemoCategories={setDemoCategories}
  demoSkills={demoSkills}
  setDemoSkills={setDemoSkills}
    
    showPaymentPopup={showPaymentPopup}          // 👈 ADD
    setShowPaymentPopup={setShowPaymentPopup}    
  />
                          </div>

                           <div className="col-lg-3 col-md-4  mt-4 ads-sidebar-container ">
                              <div className="left-ads-box">
                                  {adsList.length > 0 ? (
                                      adsList.slice(0, 5).map((ad, i) => (
                                          <div key={i} className="ad-item-small">
                                              <img
                                                  src={ad.image_url 
                                                      ? `https://kalakakshaaha.com/uploads/ads/${ad.image_url}` 
                                                      : ad.imgUrl}
                                                  alt="Ad"
                                              />
                                          </div>
                                      ))
                                  ) : (
                                      fallbackAds.map((ad, i) => (
                                          <div key={i} className="ad-item-small">
                                              <img src={ad.imgUrl} alt="Ad" />
                                          </div>
                                      ))
                                  )}
                              </div>
                          </div>

                      </div>
                  </div>
              </section>

              <Footer />
              
          </Fragment>
      );
  };

  export default TeamSingle;


